import styled from "styled-components";
import { transition } from "@m/alchemy-theme";
import { NestedCell } from "../table-cell-nested/NestedCell.styled";
export const ExpandableCell = styled(NestedCell) `
  & > div {
    position: relative;

    & > button {
      color: inherit;
      position: absolute;
      left: -25px;
      padding: 0 7px;
      margin: -10px 0;
      top: 0;
      bottom: 0;

      svg {
        transition: ${transition("base", "transform")};
        ${({ isExpanded }) => (isExpanded ? `transform: rotate(90deg)` : ``)};
      }
    }
  }
`;
